// import React, {
//   useEffect,
//   useRef,
//   useState,
//   createContext,
//   useContext,
// } from "react";
// import { createPortal } from "react-dom";
// import { X, ArrowLeft, ArrowRight } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";

// // --- START: HELPER COMPONENT ---
// // This component safely creates a portal only on the client-side
// const Portal = ({ children }) => {
//   const [mounted, setMounted] = useState(false);

//   useEffect(() => {
//     setMounted(true);
//     return () => setMounted(false);
//   }, []);

//   return mounted ? createPortal(children, document.body) : null;
// };
// // --- END: HELPER COMPONENT ---

// export const CarouselContext = createContext({
//   onCardClose: () => {},
//   currentIndex: 0,
// });

// const cn = (...classes) => classes.filter(Boolean).join(" ");

// const useOutsideClick = (ref, callback) => {
//   useEffect(() => {
//     const listener = (event) => {
//       if (!ref.current || ref.current.contains(event.target)) {
//         return;
//       }
//       callback(event);
//     };

//     document.addEventListener("mousedown", listener);
//     document.addEventListener("touchstart", listener);

//     return () => {
//       document.removeEventListener("mousedown", listener);
//       document.removeEventListener("touchstart", listener);
//     };
//   }, [ref, callback]);
// };

// export const Carousel = ({ items, initialScroll = 0 }) => {
//   // ... This component's code remains unchanged ...
//   const carouselRef = React.useRef(null);
//   const [canScrollLeft, setCanScrollLeft] = React.useState(false);
//   const [canScrollRight, setCanScrollRight] = React.useState(true);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     if (carouselRef.current) {
//       carouselRef.current.scrollLeft = initialScroll;
//       checkScrollability();
//     }
//   }, [initialScroll]);

//   const checkScrollability = () => {
//     if (carouselRef.current) {
//       const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
//       setCanScrollLeft(scrollLeft > 0);
//       setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
//     }
//   };

//   const scrollLeft = () => {
//     if (carouselRef.current) {
//       carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
//     }
//   };

//   const scrollRight = () => {
//     if (carouselRef.current) {
//       carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
//     }
//   };

//   const handleCardClose = (index) => {
//     if (carouselRef.current) {
//       const cardWidth = isMobile() ? 230 : 384;
//       const gap = isMobile() ? 4 : 8;
//       const scrollPosition = (cardWidth + gap) * (index + 1);
//       carouselRef.current.scrollTo({
//         left: scrollPosition,
//         behavior: "smooth",
//       });
//       setCurrentIndex(index);
//     }
//   };

//   const isMobile = () => {
//     return window && window.innerWidth < 768;
//   };

//   return (
//     <CarouselContext.Provider
//       value={{ onCardClose: handleCardClose, currentIndex }}
//     >
//       <div className="relative w-full">
//         <div
//           className="flex w-full overflow-x-scroll md:overflow-x-hidden overscroll-x-auto py-10 md:py-12"
//           style={{ scrollbarWidth: "none" }}
//           ref={carouselRef}
//           onScroll={checkScrollability}
//         >
//           <div
//             className={cn(
//               "absolute right-0 z-[1000] h-auto w-[5%] overflow-hidden bg-gradient-to-l"
//             )}
//           ></div>

//           <div
//             className={cn(
//               "flex flex-row justify-start gap-4 md:gap-8 md:flex-nowrap md:justify-center",
//               "mx-auto max-w-7xl px-4 md:px-2"
//             )}
//           >
//             {items.map((item, index) => (
//               <motion.div
//                 initial={{
//                   opacity: 0,
//                   y: 20,
//                 }}
//                 animate={{
//                   opacity: 1,
//                   y: 0,
//                   transition: {
//                     duration: 0.5,
//                     delay: 0.2 * index,
//                     ease: "easeOut",
//                     once: true,
//                   },
//                 }}
//                 key={"card" + index}
//                 className="rounded-3xl last:pr-4 md:last:pr-0"
//               >
//                 {item}
//               </motion.div>
//             ))}
//           </div>
//         </div>
//         <div className="mr-10 flex justify-end gap-2 md:hidden">
//           <button
//             className="relative z-40 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 disabled:opacity-50"
//             onClick={scrollLeft}
//             disabled={!canScrollLeft}
//           >
//             <ArrowLeft className="h-6 w-6 text-gray-500" />
//           </button>
//           <button
//             className="relative z-40 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 disabled:opacity-50"
//             onClick={scrollRight}
//             disabled={!canScrollRight}
//           >
//             <ArrowRight className="h-6 w-6 text-gray-500" />
//           </button>
//         </div>
//       </div>
//     </CarouselContext.Provider>
//   );
// };

// export const Card = ({ card, index, layout = false }) => {
//   const [open, setOpen] = useState(false);
//   const containerRef = useRef(null);
//   const { onCardClose } = useContext(CarouselContext);

//   // --- 1. ADDED email and phoneNumber TO STATE ---
//   const [formData, setFormData] = useState({
//     collegeName: "",
//     city: "",
//     email: "", // New
//     phoneNumber: "", // New
//     numberOfStudents: "",
//     collegeType: "",
//     sessionFormat: "",
//     selectedService: card.title,
//   });

//   // --- 2. ADDED STATE FOR VALIDATION ERRORS ---
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     function onKeyDown(event) {
//       if (event.key === "Escape") {
//         handleClose();
//       }
//     }

//     if (open) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     window.addEventListener("keydown", onKeyDown);
//     return () => window.removeEventListener("keydown", onKeyDown);
//   }, [open]);

//   useOutsideClick(containerRef, () => handleClose());

//   const handleOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setErrors({}); // Clear errors on close
//     onCardClose(index);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     // Clear the error for the field being edited
//     if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: null }));
//     }
//   };

//   // --- 3. ADDED VALIDATION LOGIC ---
//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.collegeName)
//       newErrors.collegeName = "College name is required";
//     if (!formData.city) newErrors.city = "City is required";

//     // Email validation
//     if (!formData.email) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = "Email address is invalid";
//     }

//     // Phone number validation
//     if (!formData.phoneNumber) {
//       newErrors.phoneNumber = "Phone number is required";
//     } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
//       newErrors.phoneNumber = "Phone number must be exactly 10 digits";
//     }

//     if (!formData.numberOfStudents)
//       newErrors.numberOfStudents = "Number of students is required";
//     if (!formData.collegeType)
//       newErrors.collegeType = "Please select a college type";
//     if (!formData.sessionFormat)
//       newErrors.sessionFormat = "Please select a session format";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // --- 4. UPDATED SUBMIT HANDLER TO USE VALIDATION ---
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const isValid = validateForm();
//     if (isValid) {
//       console.log("\:", formData);
//       handleClose();
//     } else {
//       console.log("Form validation failed");
//     }
//   };

//   return (
//     <>
//       <AnimatePresence>
//         {open && (
//           <Portal>
//             <div className="fixed inset-0 z-50 h-screen overflow-auto">
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 className="fixed inset-0 h-full w-full bg-black/80 backdrop-blur-lg"
//               />
//               <motion.div
//                 initial={{ opacity: 0, scale: 0.95 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 exit={{ opacity: 0, scale: 0.95 }}
//                 transition={{ duration: 0.2 }}
//                 ref={containerRef}
//                 className="relative z-[60] mx-auto my-10 h-fit max-w-2xl rounded-3xl bg-white p-6 font-sans md:p-8 dark:bg-neutral-900"
//               >
//                 <button
//                   className="absolute top-4 right-4 flex h-8 w-8 items-center justify-center rounded-full bg-black hover:bg-gray-800 transition-colors dark:bg-white dark:hover:bg-gray-200"
//                   onClick={handleClose}
//                 >
//                   <X className="h-5 w-5 text-white dark:text-black" />
//                 </button>

//                 <h2 className="text-2xl md:text-3xl font-bold text-neutral-800 mb-2 dark:text-white">
//                   Get Quotation
//                 </h2>
//                 <p className="text-sm text-neutral-600 mb-6 dark:text-neutral-400">
//                   Fill in the details below to receive a customized quote for
//                   your institution
//                 </p>

//                 {/* --- 5. UPDATED FORM JSX WITH NEW FIELDS AND ERROR MESSAGES --- */}
//                 <form onSubmit={handleSubmit} noValidate className="space-y-5">
//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       Selected Service
//                     </label>
//                     <input
//                       type="text"
//                       name="selectedService"
//                       value={formData.selectedService}
//                       readOnly
//                       className="w-full px-4 py-2.5 rounded-lg border border-neutral-300 bg-neutral-100 text-neutral-800 cursor-not-allowed dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-300"
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       Name of the College{" "}
//                       <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       name="collegeName"
//                       value={formData.collegeName}
//                       onChange={handleInputChange}
//                       required
//                       placeholder="Enter college name"
//                       className={`w-full px-4 py-2.5 rounded-lg border ${
//                         errors.collegeName
//                           ? "border-red-500"
//                           : "border-neutral-300"
//                       } focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                     />
//                     {errors.collegeName && (
//                       <p className="text-red-500 text-xs mt-1">
//                         {errors.collegeName}
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       City <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       name="city"
//                       value={formData.city}
//                       onChange={handleInputChange}
//                       required
//                       placeholder="Enter city"
//                       className={`w-full px-4 py-2.5 rounded-lg border ${
//                         errors.city ? "border-red-500" : "border-neutral-300"
//                       } focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                     />
//                     {errors.city && (
//                       <p className="text-red-500 text-xs mt-1">{errors.city}</p>
//                     )}
//                   </div>

//                   {/* NEW EMAIL FIELD */}
//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       Email <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       required
//                       placeholder="Enter SPOC email"
//                       className={`w-full px-4 py-2.5 rounded-lg border ${
//                         errors.email ? "border-red-500" : "border-neutral-300"
//                       } focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                     />
//                     {errors.email && (
//                       <p className="text-red-500 text-xs mt-1">
//                         {errors.email}
//                       </p>
//                     )}
//                   </div>

//                   {/* NEW PHONE NUMBER FIELD */}
//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       Phone Number <span className="text-red-500">*</span>
//                     </label>
//                     <div className="relative flex items-center">
//                       <span className="absolute left-3 text-neutral-500 dark:text-neutral-400 pointer-events-none">
//                         +91
//                       </span>
//                       <input
//                         type="tel"
//                         name="phoneNumber"
//                         value={formData.phoneNumber}
//                         onChange={handleInputChange}
//                         required
//                         maxLength="10"
//                         placeholder="98765 43210"
//                         className={`w-full pl-12 pr-4 py-2.5 rounded-lg border ${
//                           errors.phoneNumber
//                             ? "border-red-500"
//                             : "border-neutral-300"
//                         } focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                       />
//                     </div>
//                     {errors.phoneNumber && (
//                       <p className="text-red-500 text-xs mt-1">
//                         {errors.phoneNumber}
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       Number of Students (minimum 50){" "}
//                       <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       name="numberOfStudents"
//                       value={formData.numberOfStudents}
//                       onChange={handleInputChange}
//                       required
//                       min="50"
//                       placeholder="Enter number of students"
//                       className={`w-full px-4 py-2.5 rounded-lg border ${
//                         errors.numberOfStudents
//                           ? "border-red-500"
//                           : "border-neutral-300"
//                       } focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                     />
//                     {errors.numberOfStudents && (
//                       <p className="text-red-500 text-xs mt-1">
//                         {errors.numberOfStudents}
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       College Type <span className="text-red-500">*</span>
//                     </label>
//                     <select
//                       name="collegeType"
//                       value={formData.collegeType}
//                       onChange={handleInputChange}
//                       required
//                       className={`w-full px-4 py-2.5 rounded-lg border ${
//                         errors.collegeType
//                           ? "border-red-500"
//                           : "border-neutral-300"
//                       } bg-white text-neutral-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                     >
//                       <option value="" className="text-neutral-500">
//                         Select college type
//                       </option>
//                       <option
//                         value="government"
//                         className="text-neutral-800 dark:text-white"
//                       >
//                         Government
//                       </option>
//                       <option
//                         value="private"
//                         className="text-neutral-800 dark:text-white"
//                       >
//                         Private
//                       </option>
//                     </select>
//                     {errors.collegeType && (
//                       <p className="text-red-500 text-xs mt-1">
//                         {errors.collegeType}
//                       </p>
//                     )}
//                   </div>

//                   <div>
//                     <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
//                       Session Format <span className="text-red-500">*</span>
//                     </label>
//                     <select
//                       name="sessionFormat"
//                       value={formData.sessionFormat}
//                       onChange={handleInputChange}
//                       required
//                       className={`w-full px-4 py-2.5 rounded-lg border ${
//                         errors.sessionFormat
//                           ? "border-red-500"
//                           : "border-neutral-300"
//                       } bg-white text-neutral-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-800 dark:border-neutral-700 dark:text-white`}
//                     >
//                       <option value="" className="text-neutral-500">
//                         Select session format
//                       </option>
//                       <option
//                         value="online"
//                         className="text-neutral-800 dark:text-white"
//                       >
//                         Online
//                       </option>
//                       <option
//                         value="offline"
//                         className="text-neutral-800 dark:text-white"
//                       >
//                         Offline
//                       </option>
//                     </select>
//                     {errors.sessionFormat && (
//                       <p className="text-red-500 text-xs mt-1">
//                         {errors.sessionFormat}
//                       </p>
//                     )}
//                   </div>

//                   <button
//                     type="submit"
//                     className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg transition-colors mt-6"
//                   >
//                     Submit Request
//                   </button>
//                 </form>
//               </motion.div>
//             </div>
//           </Portal>
//         )}
//       </AnimatePresence>

//       <motion.div className="relative z-10 flex h-80 w-56 flex-col justify-between overflow-hidden rounded-3xl bg-gray-100 md:h-[32rem] md:w-72 dark:bg-neutral-900">
//         <div className="pointer-events-none absolute inset-x-0 top-0 z-30 h-full bg-gradient-to-b from-black/50 via-transparent to-transparent" />
//         <div className="relative z-40 p-6 flex-1 flex flex-col justify-between">
//           <div>
//             <p className="text-left font-sans text-sm font-medium text-white md:text-base">
//               {card.category}
//             </p>
//             <p className="mt-2 text-left font-sans text-xl font-semibold text-white md:text-3xl">
//               {card.title}
//             </p>
//           </div>
//           <button
//             onClick={handleOpen}
//             className="mt-auto bg-white hover:bg-gray-100 text-black font-semibold py-3 px-6 rounded-lg transition-colors shadow-lg"
//           >
//             Get Quotation
//           </button>
//         </div>
//         <BlurImage
//           src={card.src}
//           alt={card.title}
//           className="absolute inset-0 z-10 object-cover"
//         />
//       </motion.div>
//     </>
//   );
// };

// export const BlurImage = ({ height, width, src, className, alt, ...rest }) => {
//   // ... This component's code remains unchanged ...
//   const [isLoading, setLoading] = useState(true);
//   return (
//     <img
//       className={cn(
//         "h-full w-full transition duration-300",
//         isLoading ? "blur-sm" : "blur-0",
//         className
//       )}
//       onLoad={() => setLoading(false)}
//       src={src}
//       width={width}
//       height={height}
//       loading="lazy"
//       decoding="async"
//       alt={alt ? alt : "Background of a beautiful view"}
//       {...rest}
//     />
//   );
// };

import React, {
  useEffect,
  useRef,
  useState,
  createContext,
  useContext,
} from "react";
import { createPortal } from "react-dom";
import { X, ArrowLeft, ArrowRight, Mail, MessageCircle } from "lucide-react"; // Added new icons
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { baseURL } from "@/utility/api";

// --- START: HELPER COMPONENT (UNCHANGED) ---
const Portal = ({ children }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  return mounted ? createPortal(children, document.body) : null;
};
// --- END: HELPER COMPONENT ---

export const CarouselContext = createContext({
  onCardClose: () => {},
  currentIndex: 0,
});

const cn = (...classes) => classes.filter(Boolean).join(" ");

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      callback(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, callback]);
};

// --- CAROUSEL COMPONENT (UNCHANGED) ---
export const Carousel = ({ items, initialScroll = 0 }) => {
  // ... This component's code remains unchanged ...
  const carouselRef = React.useRef(null);
  const [canScrollLeft, setCanScrollLeft] = React.useState(false);
  const [canScrollRight, setCanScrollRight] = React.useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft = initialScroll;
      checkScrollability();
    }
  }, [initialScroll]);

  const checkScrollability = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
    }
  };

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const handleCardClose = (index) => {
    if (carouselRef.current) {
      const cardWidth = isMobile() ? 230 : 384;
      const gap = isMobile() ? 4 : 8;
      const scrollPosition = (cardWidth + gap) * (index + 1);
      carouselRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
      setCurrentIndex(index);
    }
  };

  const isMobile = () => {
    return window && window.innerWidth < 768;
  };

  return (
    <CarouselContext.Provider
      value={{ onCardClose: handleCardClose, currentIndex }}
    >
      <div className="relative w-full">
        <div
          className="flex w-full overflow-x-scroll md:overflow-x-hidden overscroll-x-auto py-10 md:py-12"
          style={{ scrollbarWidth: "none" }}
          ref={carouselRef}
          onScroll={checkScrollability}
        >
          <div
            className={cn(
              "absolute right-0 z-[1000] h-auto w-[5%] overflow-hidden bg-gradient-to-l"
            )}
          ></div>

          <div
            className={cn(
              "flex flex-row justify-start gap-4 md:gap-16 md:flex-nowrap md:justify-center",
              "mx-auto max-w-7xl px-4 md:px-2"
            )}
          >
            {items.map((item, index) => (
              <motion.div
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                  transition: {
                    duration: 0.5,
                    delay: 0.2 * index,
                    ease: "easeOut",
                    once: true,
                  },
                }}
                key={"card" + index}
                className="rounded-3xl last:pr-4 md:last:pr-0"
              >
                {React.cloneElement(item, { imageOffset: index === 2 })}
              </motion.div>
            ))}
          </div>
        </div>
        <div className="mr-10 flex justify-end gap-2 md:hidden">
          <button
            className="relative z-40 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 disabled:opacity-50"
            onClick={scrollLeft}
            disabled={!canScrollLeft}
          >
            <ArrowLeft className="h-6 w-6 text-gray-500" />
          </button>
          <button
            className="relative z-40 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 disabled:opacity-50"
            onClick={scrollRight}
            disabled={!canScrollRight}
          >
            <ArrowRight className="h-6 w-6 text-gray-500" />
          </button>
        </div>
      </div>
    </CarouselContext.Provider>
  );
};

// A simple spinner component to show loading state
const Spinner = () => (
  <svg
    className="animate-spin h-5 w-5 text-white"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const Card = ({ card, index, imageOffset = false }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const { onCardClose } = useContext(CarouselContext);

  // --- 1. ADDED STATES for loading and quotation data ---
  const [isLoading, setIsLoading] = useState(false);
  const [quotationData, setQuotationData] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [actionLoading, setActionLoading] = useState(null);
  const initialFormData = {
    collegeName: "",
    city: "",
    email: "",
    phoneNumber: "",
    numberOfStudents: "",
    collegeType: "",
    collegeGraduation: "",
    sessionFormat: "",
    selectedService: card.title,
  };
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === "Escape") {
        handleClose();
      }
    }
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  useOutsideClick(containerRef, () => handleClose());

  const handleOpen = () => {
    setOpen(true);
  };

  // --- 2. UPDATED handleClose to reset all states ---
  const handleClose = () => {
    setOpen(false);
    onCardClose(index);
    // Reset all states for a clean slate next time
    setTimeout(() => {
      setFormData(initialFormData);
      setErrors({});
      setIsLoading(false);
      setQuotationData(null);
      setApiError(null);
    }, 300); // Delay to allow exit animation
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.collegeName)
      newErrors.collegeName = "College name is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email address is invalid";
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }
    if (!formData.numberOfStudents) {
      newErrors.numberOfStudents = "Number of students is required";
    } else if (parseInt(formData.numberOfStudents, 10) < 50) {
      newErrors.numberOfStudents = "Minimum 50 students required";
    }
    if (!formData.collegeType)
      newErrors.collegeType = "Please select a college type";
    if (!formData.sessionFormat)
      newErrors.sessionFormat = "Please select a session format";
    if (!formData.collegeGraduation)
      newErrors.collegeGraduation =
        "Please select whether Undergrad  or Postgrad/MBA";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // --- 3. UPDATED handleSubmit to call the backend API ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError(null);
    if (!validateForm()) {
      console.log("Form validation failed");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/college-service/create-quotation`,
        formData
      );

      if (!response.message === "Quotation request stored successfully.") {
        throw new Error(response.message || "Failed to get quotation.");
      }

      setQuotationData(response.data.data); // Store the 'data' object from backend
    } catch (error) {
      console.error("API Error:", error);
      setApiError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // --- 4. RENDER LOGIC: Conditionally show Form, Loading, or Quotation View ---
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="text-center py-16">
          <h2 className="text-2xl font-bold text-neutral-800 dark:text-white mb-2">
            Getting your customized quotation ready...
          </h2>
          <p className="text-neutral-600 dark:text-neutral-400">
            Please wait a moment.
          </p>
        </div>
      );
    }

    if (quotationData) {
      // 1. Destructure `priceRange` from the data
      const {
        totalPrice,
        priceRange, // <-- ADD THIS
        pricePerStudent,
        numberOfStudents,
        sessionFormat,
        userEmail,
        serviceName,
        collegeName,
        collegeGraduation,
        collegeType,
      } = quotationData;

      // 2. Update the mailBody to show the estimated range
      const mailSubject = `Quotation for ${serviceName} at ${collegeName}`;
      const mailBody = `Dear Charchit,

We have received a quotation request from the website.

Here are the details:
- Service: ${serviceName}
- Number of Students: ${numberOfStudents}
- College Type: ${collegeType}
- Degree Level: ${collegeGraduation}
- Session Format: ${sessionFormat}
- Estimated Price Range: ₹${priceRange.lower.toLocaleString(
        "en-IN"
      )} - ₹${priceRange.upper.toLocaleString("en-IN")}

Contact Person's Email: ${userEmail}

We would like to proceed with this quotation.

Best regards,
${collegeName}`;

      const mailtoLink = `mailto:support@off-campus.in?subject=${encodeURIComponent(
        mailSubject
      )}&body=${encodeURIComponent(mailBody)}`;

      const whatsappText = `Hello, I'm interested in the "${serviceName}" service for ${collegeName}. We have received a quotation and would like to discuss it further.`;
      const whatsappLink = `https://wa.me/919560699151?text=${encodeURIComponent(
        whatsappText
      )}`;

      return (
        <>
          <h2 className="text-2xl md:text-3xl font-bold text-center text-neutral-800 dark:text-white">
            Here is Your Quotation
          </h2>

          <p className="text-center text-neutral-500 dark:text-neutral-400 mt-1">
            For:{" "}
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
              {serviceName}
            </span>
          </p>

          <div className="my-8 bg-blue-50 dark:bg-neutral-800/50 p-6 rounded-xl text-center">
            <div className="flex justify-between items-center">
              <div className="text-left">
                {/* 3. Update the display text */}
                <p className="text-lg text-neutral-600 dark:text-neutral-400">
                  Estimated Price
                </p>
                {/* 4. Display the price range */}
                <p className="text-4xl md:text-5xl font-bold text-blue-600 dark:text-blue-400">
                  ₹{priceRange.lower.toLocaleString("en-IN")} - ₹
                  {priceRange.upper.toLocaleString("en-IN")}
                </p>
              </div>
              <div className="text-right text-sm text-neutral-500 dark:text-neutral-400 border-l-2 pl-4 border-dashed">
                For {numberOfStudents} Students | {sessionFormat}
              </div>
            </div>
          </div>

          {sessionFormat === "offline" && (
            <p className="text-xs text-center text-neutral-500 mt-[-1rem] mb-6">
              *Offline session may have additional travel allowance.
            </p>
          )}

          {/* ... (rest of your component code for buttons remains the same) ... */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            <a
              href={mailtoLink}
              onClick={() => {
                if (actionLoading) return;

                setActionLoading("mail");

                setTimeout(() => setActionLoading(null), 15000); // Reset after 1.5s
              }}
              className={cn(
                "flex items-center justify-center gap-2 w-full bg-gray-800 hover:bg-black text-white font-medium py-3 rounded-lg transition-colors",

                actionLoading && "opacity-50 cursor-not-allowed" // Style when any action is loading
              )}
            >
              {actionLoading === "mail" ? (
                <Spinner />
              ) : (
                <>
                  <Mail className="h-5 w-5" /> Mail Quotation
                </>
              )}
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                if (actionLoading) return;

                setActionLoading("whatsapp");

                setTimeout(() => setActionLoading(null), 1500); // Reset after 1.5s
              }}
              className={cn(
                "flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 rounded-lg transition-colors",

                actionLoading && "opacity-50 cursor-not-allowed" // Style when any action is loading
              )}
            >
              {actionLoading === "whatsapp" ? (
                <Spinner />
              ) : (
                <>
                  <MessageCircle className="h-5 w-5" /> Connect on WhatsApp
                </>
              )}
            </a>
          </div>
        </>
      );
    }

    // Default View: The Form
    return (
      <>
        <h2 className="text-2xl md:text-3xl font-bold text-neutral-800 mb-2 dark:text-white">
          Get Quotation
        </h2>
        <p className="text-sm text-neutral-600 mb-6 dark:text-neutral-400">
          Fill in the details below to receive a customized quote for your
          institution
        </p>

        {/* --- The form JSX remains the same as you provided --- */}
        <form onSubmit={handleSubmit} noValidate className="space-y-5">
          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Selected Service
            </label>
            <input
              type="text"
              name="selectedService"
              value={formData.selectedService}
              readOnly
              className="w-full px-4 py-2.5 rounded-lg border border-neutral-300 bg-neutral-100 text-neutral-700 cursor-not-allowed dark:bg-neutral-700 dark:border-neutral-600 dark:text-neutral-300"
            />
          </div>

          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Name of the College <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="collegeName"
              value={formData.collegeName}
              onChange={handleInputChange}
              required
              placeholder="Enter college name"
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.collegeName ? "border-red-500" : "border-neutral-300"
              } bg-white text-neutral-900 placeholder:text-neutral-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white dark:placeholder:text-neutral-500`}
            />
            {errors.collegeName && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.collegeName}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              City <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              required
              placeholder="Enter city"
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.city ? "border-red-500" : "border-neutral-300"
              } bg-white text-neutral-900 placeholder:text-neutral-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white dark:placeholder:text-neutral-500`}
            />
            {errors.city && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.city}
              </p>
            )}
          </div>

          {/* NEW EMAIL FIELD */}
          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="Enter SPOC email"
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.email ? "border-red-500" : "border-neutral-300"
              } bg-white text-neutral-900 placeholder:text-neutral-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white dark:placeholder:text-neutral-500`}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.email}
              </p>
            )}
          </div>

          {/* NEW PHONE NUMBER FIELD */}
          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Phone Number <span className="text-red-500">*</span>
            </label>
            <div className="relative flex items-center">
              <span className="absolute left-3 text-neutral-500 dark:text-neutral-400 pointer-events-none">
                +91
              </span>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                required
                maxLength="10"
                placeholder="98765 43210"
                className={`w-full pl-12 pr-4 py-2.5 rounded-lg border ${
                  errors.phoneNumber ? "border-red-500" : "border-neutral-300"
                } bg-white text-neutral-900 placeholder:text-neutral-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white dark:placeholder:text-neutral-500`}
              />
            </div>
            {errors.phoneNumber && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.phoneNumber}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Number of Students (minimum 50){" "}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              name="numberOfStudents"
              value={formData.numberOfStudents}
              onChange={handleInputChange}
              required
              min="50"
              placeholder="Enter number of students"
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.numberOfStudents
                  ? "border-red-500"
                  : "border-neutral-300"
              } bg-white text-neutral-900 placeholder:text-neutral-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white dark:placeholder:text-neutral-500`}
            />
            {errors.numberOfStudents && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.numberOfStudents}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              College Type <span className="text-red-500">*</span>
            </label>
            <select
              name="collegeType"
              value={formData.collegeType}
              onChange={handleInputChange}
              required
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.collegeType ? "border-red-500" : "border-neutral-300"
              } bg-white text-neutral-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white`}
            >
              <option value="" className="text-neutral-500">
                Select college type
              </option>
              <option
                value="government"
                className="text-neutral-900 dark:text-white"
              >
                Government
              </option>
              <option
                value="private"
                className="text-neutral-900 dark:text-white"
              >
                Private
              </option>
            </select>
            {errors.collegeType && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.collegeType}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Degree Level <span className="text-red-500">*</span>
            </label>
            <select
              name="collegeGraduation"
              value={formData.collegeGraduation}
              onChange={handleInputChange}
              required
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.collegeGraduation
                  ? "border-red-500"
                  : "border-neutral-300"
              } bg-white text-neutral-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white`}
            >
              <option value="" className="text-neutral-500">
                Select
              </option>
              <option
                value="undergrad"
                className="text-neutral-900 dark:text-white"
              >
                Undergrad
              </option>
              <option
                value="postgrad/mba"
                className="text-neutral-900 dark:text-white"
              >
                Postgrad/MBA
              </option>
            </select>
            {errors.collegeGraduation && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.collegeGraduation}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm text-left font-medium text-neutral-700 mb-2 dark:text-neutral-300">
              Session Format <span className="text-red-500">*</span>
            </label>
            <select
              name="sessionFormat"
              value={formData.sessionFormat}
              onChange={handleInputChange}
              required
              className={`w-full px-4 py-2.5 rounded-lg border ${
                errors.sessionFormat ? "border-red-500" : "border-neutral-300"
              } bg-white text-neutral-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all dark:bg-neutral-700 dark:border-neutral-600 dark:text-white`}
            >
              <option value="" className="text-neutral-500">
                Select session format
              </option>
              <option
                value="online"
                className="text-neutral-900 dark:text-white"
              >
                Online
              </option>
              <option
                value="offline"
                className="text-neutral-900 dark:text-white"
              >
                Offline
              </option>
            </select>
            {errors.sessionFormat && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {errors.sessionFormat}
              </p>
            )}
          </div>

          {apiError && (
            <p className="text-red-500 text-sm mt-4 text-center bg-red-50 dark:bg-red-900/20 p-2 rounded-md">
              Error: {apiError}
            </p>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg transition-colors mt-6"
          >
            Get My Quotation
          </button>
        </form>
      </>
    );
  };

  return (
    <>
      <AnimatePresence>
        {open && (
          <Portal>
            <div className="fixed inset-0 z-50 h-screen overflow-auto">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 h-full w-full bg-black/80 backdrop-blur-lg"
              />
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.2 }}
                ref={containerRef}
                className="relative z-[60] mx-auto my-10 h-fit max-w-2xl rounded-3xl bg-white p-6 font-sans md:p-8 dark:bg-neutral-900"
              >
                <button
                  className="absolute top-4 right-4 flex h-8 w-8 items-center justify-center rounded-full bg-black hover:bg-gray-800 transition-colors dark:bg-white dark:hover:bg-gray-200"
                  onClick={handleClose}
                >
                  <X className="h-5 w-5 text-white dark:text-black" />
                </button>
                {renderContent()}{" "}
                {/* <-- Renders Form, Loading, or Quotation */}
              </motion.div>
            </div>
          </Portal>
        )}
      </AnimatePresence>

      <motion.div className="relative z-10 flex h-80 w-56 flex-col justify-between overflow-hidden rounded-3xl bg-gray-100 md:h-[32rem] md:w-72 dark:bg-neutral-900">
        <div className="pointer-events-none absolute inset-x-0 top-0 z-30 h-full bg-gradient-to-b from-black/50 via-transparent to-transparent" />
        <div className="relative z-40 p-6 flex-1 flex flex-col justify-between">
          <div>
            <p className="text-left font-sans text-sm font-medium text-white md:text-base">
              {card.category}
            </p>
            <p className="mt-2 text-left font-sans text-xl font-semibold text-white md:text-3xl">
              {card.title}
            </p>
          </div>
          <button
            onClick={handleOpen}
            className="mt-auto bg-white hover:bg-gray-100 text-black font-semibold py-3 px-6 rounded-lg transition-colors shadow-lg"
          >
            Get Quotation
          </button>
        </div>
        <BlurImage
          src={card.src}
          alt={card.title}
          className={`absolute inset-0 z-10 object-cover ${
            imageOffset ? "translate-y-8 md:translate-y-12" : ""
          }`}
        />
      </motion.div>
    </>
  );
};

// --- BLUR IMAGE COMPONENT (UNCHANGED) ---
export const BlurImage = ({ height, width, src, className, alt, ...rest }) => {
  // ... This component's code remains unchanged ...
  const [isLoading, setLoading] = useState(true);
  return (
    <img
      className={cn(
        "h-full w-full transition duration-300",
        isLoading ? "blur-sm" : "blur-0",
        className
      )}
      onLoad={() => setLoading(false)}
      src={src}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      alt={alt ? alt : "Background of a beautiful view"}
      {...rest}
    />
  );
};
